import { IFilterValue } from "./api/types";

interface IFilterItem {
  key: string;
  value: IFilterValue | Array<IFilterValue>;
}

const DELIMITERS = {
  FILTER: ';',
  KEY_VALUE: ':',
  VALUE: ','
} as const;

const isArrayValue = (value: string): boolean =>
  value.startsWith('[') && value.endsWith(']');

const trimSlashes = (value: string): string =>
  value.replace(/^\//, '').replace(/\/$/, '');

const parseArrayValue = (value: string): IFilterValue[] => {
  const content = value.slice(1, -1);
  return content ? content.split(DELIMITERS.VALUE).map(v => decodeURIComponent(v)) : [''];
};

const parseValue = (value?: string): IFilterValue | IFilterValue[] => {
  if (!value) return '';

  return isArrayValue(value)
    ? parseArrayValue(value)
    : trimSlashes(decodeURIComponent(value));
};

const parseFilterItem = (filter: string): IFilterItem => {
  const [key, value] = filter.split(DELIMITERS.KEY_VALUE);
  return { key, value: parseValue(value) };
};

export const parseFilterQueryString = (queryString?: string): IFilterItem[] => {
  if (!queryString) return [];

  return queryString
    .split(DELIMITERS.FILTER)
    .map(parseFilterItem);
};
